<template>
    <div class="m-media">
        <div class="m-live">
            <h5 class="title"></h5>

            <div class="live-view">
                <div class="live-plat">
                    <div class="u-btn" :class="{'act' : live_active == index}" v-for="(item,index) in live_data" :key="index"
                    @click="live_active = index">
                        {{ item.platName }}
                    </div>
                </div>

                <div class="view">
                    <div class="live-pannel" v-if="live_ready">
                        <iframe v-if="live_data[live_active].isOpen" v-bind:src="live_data[live_active].liveUrl" frameborder="0" width="100%" height="100%"></iframe>
                        <div class="cover" v-else><img :src="live_data[live_active].logo" :alt="live_data[live_active].platName" srcset=""></div>
                    </div>

                    <loading v-else/>
                </div>
            </div>
        </div>

        <div class="m-news">
            <h5 class="title"></h5>
            <div class="view">
                <a href="https://www.m3guo.com/v2/news/report/index.html" target="_blank" class="u-btn more"></a>

                <div class="list">
                    <vuescroll :ops="ops">
                    <ul>
                        <li v-for="(item,index) in news_data" :key="index">
                            <a v-bind:href="item.url" target="_blank" rel="noopener noreferrer"><span class="news-title">{{ item.title }}</span><span v-if="item.showTime" class="time">{{ timeFormat(new Date(item.showTime),'mm-dd' ) }}</span></a>                     
                        </li>
                    </ul>
                    </vuescroll>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import vuescroll from 'vuescroll';

export default {
    components: {
        vuescroll,
    },       
    data (){
        return {
            live_data : [],
            news_data : [],
            live_ready : false,
            live_active : 0,
            ops: {
                rail: {
                    opacity: 1,
                    background : '#000',
                },
                bar: {
                    background: '#2b4d69',
                    keepShow : true,
                }
            },                
        }
    },
    props :{
        'active' : {
            default : false,
        }
    },
    created (){
        // this.render_live();
        // this.render_news();
    },
    watch : {
        active (val){
            if(val && !this.live_ready){
                this.render_live();
                this.render_news();               
            }
        },
    },
    methods : {
        render_live (){
            this.$axios.get(this.$ajax_url_map.live)
            .then(
                res => {
                    this.live_data = res
                    this.live_ready = true
                },
                rej => {}
            )
        },
        render_news (){
            this.$axios.get(this.$ajax_url_map.news)
            .then(
                res => {
                    res.sort((a,b)=>{
                        //console.log(b.showTime)
                        //return b.showTime - a.showTime
                        return (+new Date(b.showTime)) - (+new Date(a.showTime))
                    })                    
                    this.news_data = res
                },
                rej => {}
            )
        },
        timeFormat(date, fmt){
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;    
        },                
    },
}
</script>

<style scoped>

    .m-media{
        display: flex;
        justify-content: space-between;
        margin-top: 140px;
    }

    .m-live{
        position: relative;
    }

    .m-live .title{
        width: 238px;
        height: 56px;
        margin-bottom: 40px;
        background-image: url(~@/assets/images/media/title-1.png);
    }

    .live-plat{       
        display: flex;
        position: absolute;
        right: 0;
        top: 0;
    }

    .m-live .u-btn{
        position: relative;
        padding: 0 35px 8px;
        font-size: 20px;
        font-weight: 700;
        color: #6b8fb3;
        border-bottom: 3px solid #39546f;
    }

    .m-live .u-btn.act{
        color: #ffd247;
        border-bottom: 4px solid #ffd247;
    }

    .m-live .u-btn.act::after{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        bottom: -16px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
        border-top: 16px solid #ffd247;        
    }

    .live-view .view{
        position: relative;
        width: 770px;
        height: 450px;
        background-image: url(~@/assets/images/media/bg-live.png);
    }

    .live-view .live-pannel{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 750px;
        height: 430px;    
        box-sizing: border-box;
        transform: translate(-50%,-50%);
    }

    .live-pannel .cover{
        width: 100%;
        height: 100%;
    }

    .live-pannel .cover img{
        width: 100%;
        height: 100%;        
    }

    .m-news{
        position: relative;
        /* margin-left: 55px; */
    }

    .m-news .title{
        width: 239px;
        height: 56px;
        margin-bottom: 40px;
        background-image: url(~@/assets/images/media/title-2.png);
    }

    .m-news .more{
        position: absolute;
        right: 50px;
        top: 12px;
        display: block;
        width: 52px;
        height: 17px;
        background-image: url(~@/assets/images/media/more.png);
    }

    .m-news .list{
        width: 575px;
        height: 450px;
    }

    .m-news li{
        margin-right: 44px;        
        font-size: 14px;
        /* margin-top: 20px; */
        padding: 20px 12px 20px;
        border-bottom: 1px solid #4c525f;      
    }

    .m-news a{
        transition: all .3s ease-in;
        color: #ffffff;
    }

    .m-news li:hover a{
        color: #ffc330;
    }

    .m-news .time{
        float: right;
    }

    .m-news .news-title{
        display: inline-block;
        max-width: 420px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;        
    }
</style>


// WEBPACK FOOTER //
// src/components/page/media.vue